import {Slide, View} from 'native-base';
import React, {useEffect, useRef} from 'react';
import {Platform, UIManager} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';

import {useGetFlyoutWidth} from 'hooks/useGetFlyoutWidth';
import {useReadOcrm} from 'hooks/useReadOcrm';
import {useGetTextFromApi} from 'hooks/useGetTextFromApi';

import {Offer, OfferSource} from 'models/Offer';

import {FCC} from '../../../../types';

import {ConnectedOfferDetailsProps} from 'containers/OfferDetails';

interface SlideFlyoutProps {
  showSlideFlyout: boolean;
  selectedOffer?: Offer;
  checkIsDeepLinkingInWebView?: boolean;
}

const OfferDetailsFlyout: FCC<SlideFlyoutProps> = ({
  showSlideFlyout,
  children,
  selectedOffer,
  checkIsDeepLinkingInWebView,
}) => {
  const width = useGetFlyoutWidth();
  const viewRef = useRef();
  const isOcrm = selectedOffer?.source === OfferSource.ocrm;
  const termsUrl = isOcrm
    ? selectedOffer.ocrm.rewards[0].links.link.find(
        link => link.rel === 'terms'
      )?.href
    : undefined;
  const ocrmPostAcceptMessageUrl = isOcrm
    ? selectedOffer.ocrm.rewards[0].links.link.find(
        link => link.rel === 'postAcceptMessage'
      )?.href
    : undefined;
  const {text, error} = useGetTextFromApi(termsUrl);
  const {text: ocrmPostAcceptMessage} = useGetTextFromApi(
    ocrmPostAcceptMessageUrl
  );
  const ocrmTerms = error ? '' : text;
  const receiveLink =
    selectedOffer?.source === OfferSource.ocrm
      ? selectedOffer.ocrm.links.link.find(l => l.rel === 'receive')?.href
      : undefined;

  useReadOcrm(receiveLink);

  useEffect(() => {
    if (viewRef.current && showSlideFlyout && Platform.OS === 'web') {
      setTimeout(() => UIManager?.focus(viewRef.current), 250);
    }
  });

  // Passing the ocrm text into the child component
  const enhancedChildren = React.Children.map(children, child => {
    if (React.isValidElement<ConnectedOfferDetailsProps>(child)) {
      return React.cloneElement<ConnectedOfferDetailsProps>(child, {
        ocrmTerms,
        ocrmPostAcceptMessage,
        ...child.props,
      });
    }
    return child;
  });

  if (checkIsDeepLinkingInWebView) {
    return (
      <View height="100vh" backgroundColor="white">
        {children}
      </View>
    );
  }

  return (
    <Slide
      ref={viewRef}
      in={showSlideFlyout}
      style={{outlineStyle: 'none'}}
      backgroundColor="white"
      placement="right"
      height="100%"
      flex={1}
      width={width}
      duration={250}>
      <SafeAreaView style={{flex: 1}} edges={['top', 'right', 'left']}>
        {enhancedChildren}
      </SafeAreaView>
    </Slide>
  );
};
export default OfferDetailsFlyout;
